import { useActivityParent } from "PFApp/activities/show/hooks/use_activity_parent";
import { useDetailsPanelsActions } from "PFApp/booking/components/details_panel";
import { Button, ButtonProps } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { useShortlistBook } from "PFCore/hooks/queries/shortlists/use_shortlist_actions";
import { useShortlistsInvalidate } from "PFCore/hooks/queries/shortlists/use_shortlists_invalidate";
import { Activity } from "PFCore/types/activity";
import { useTranslation } from "react-i18next";

import {
  BookingDataItem,
  BookingFormMode
} from "../../../../booking/components/booking_form/booking_form.types";

type BookButtonProps = {
  activity: Activity;
  profileId?: number;
  shortlistId: number;
  buttonKind?: ButtonProps["kind"];
  disabled?: boolean;
  small?: boolean;
  className?: string;
};

export const BookButton = ({
  activity,
  profileId,
  shortlistId,
  buttonKind,
  disabled,
  small,
  className
}: BookButtonProps) => {
  const { t } = useTranslation(["activities", "translation"]);

  const { openBookingFormSidePanel } = useDetailsPanelsActions();

  const parentActivity = useActivityParent(activity);
  const { invalidateShortlists } = useShortlistsInvalidate();
  const { mutateAsync: bookShortlist } = useShortlistBook();

  const isCompleted = activity?.state === "complete" || parentActivity?.state === "complete";

  const handleBookShortlist = async (shortlistId?: number, bookings?: BookingDataItem[]) => {
    if (!shortlistId) {
      return;
    }
    await bookShortlist({
      id: shortlistId,
      skipBookingsCreation: true,
      bookings: bookings?.map(({ startDate }) => ({ startDate }))
    });
  };

  return (
    <Tooltip content={t("translation:bookingNotAvailable")} disabled={!isCompleted}>
      <Button
        text={t("activities:show.shortlist.bookManually")}
        kind={buttonKind || "secondary"}
        disabled={disabled || isCompleted}
        small={small}
        className={className}
        onClick={(event) => {
          event.stopPropagation();
          openBookingFormSidePanel(
            {
              profileId,
              activityId: activity?.id,
              shortlistId
            },
            {
              mode: BookingFormMode.Create,
              onSuccess: () => invalidateShortlists(activity?.id),
              customPreSubmitAction: handleBookShortlist
            }
          );
        }}
      />
    </Tooltip>
  );
};
